<template>
    <div>
        <p><button class="btn btn-default btn-xs" @click="processAssets" v-if="!processing">Process All Campaigns</button></p>
        <div class="alert alert-light" role="alert" v-if="processing">
            Processing <strong>{{ name }}</strong>
            <span v-if="progress_detail" class="text-muted ml-2">— {{ progress_detail }}</span>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                name: '',
                processing: false,
                progress_detail: ''
            }
        },
        created() {
            Echo.private('campaign-status').listen('.crawler-status', (e) => {
                if (e) {
                    this.name = e.campaign_name;
                    if (e.status === 'crawling' || e.status === 'processing_prompts') {
                        this.processing = true;
                        if (e.status === 'crawling' && e.progress) {
                            this.progress_detail = e.progress.engine
                                + ': ' + e.progress.keyword
                                + ' (' + e.progress.keywords_completed + '/' + e.progress.keywords_total + ')';
                        } else if (e.status === 'processing_prompts' && e.progress) {
                            var detail = 'AI: ' + (e.progress.prompt || '');
                            if (e.progress.provider) {
                                detail += ' via ' + e.progress.provider;
                            }
                            this.progress_detail = detail;
                        }
                    } else {
                        this.processing = false;
                        this.progress_detail = '';
                    }
                }
            });
        },
        methods: {
            processAssets(event) {
                event.preventDefault();
                if (!this.processing) {
                    this.processing = true;
                    axios.put('/api/search_results/process-all')
                    .then((response) => {})
                    .catch((error) => {
                        console.log(error.response);
                        this.processing = false;
                    });
                }
            }
        }
    }
</script>
